<template>
  <div>
     <!-- Snackbar for showing download progress -->
     <v-snackbar v-model="loading" color="info" timeout="-1" top right>
      Download in progress, please wait...
    </v-snackbar>
    <v-container fluid>
      <v-row>
        <!-- Loop through each photo and create a card for it -->
        <v-col
          v-for="(photo, index) in photos"
          :key="index"
          cols="12" sm="6" md="4" lg="3"
        >
          <v-card
            class="mx-auto photo-card"
            outlined
            style="position: relative; overflow: hidden;"
          >
            <!-- Display the preview image -->
            <v-img
              :src="generatePreviewUrl(photo.url)"
              :alt="photo.name"
              height="200"
              cover
              class="rounded-corners"
            ></v-img>

            <!-- Show the file name at the bottom of the image -->
            <v-card-subtitle class="file-name">{{ photo.name }}</v-card-subtitle>

            <!-- Download button that appears on hover -->
            <v-btn
              icon
              class="download-btn"
              @click.stop="downloadPhoto(photo.url, photo.name)"
              style="position: absolute; top: 10px; right: 10px;"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-card>
        </v-col>
        
      </v-row>
    </v-container>
  </div>
</template>

<script>
import photos from '@/assets/stock-photos.json'; // JSON file containing image data

export default {
  data() {
    return {
      photos, // Load images from JSON
      dialog: false, // For controlling the preview dialog
      selectedPhoto: null, // The photo to display in the preview dialog
      loading: false, // Flag to indicate download progress
    };
  },
  created() {
    this.photos = photos.sort((a, b) => a.height - b.height);
  },
  methods: {
    // Generate the preview URL based on the full image URL
    generatePreviewUrl(fullUrl) {
      const previewUrl = 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_320/u_';
      return previewUrl + fullUrl;
    },
     downloadPhoto(url, name) {
      this.loading = true; // Set loading to true when the download starts
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);  // Create a URL for the blob
          link.download = name;  // Set the file name for the download
          document.body.appendChild(link);  // Append the link to the DOM
          link.click();  // Trigger the download
          document.body.removeChild(link);  // Clean up and remove the link from the DOM
          this.loading = false; // Set loading to false after the download completes
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
          this.loading = false; // Set loading to false if there's an error
        });
    }
  }
};
</script>

<style scoped>
.snackbar-top-right {
  position: fixed !important;
  top: 20px;
  right: 20px;
  z-index: 9999; /* Ensure it stays on top */
}
  .photo-card {
  border-radius: 8px; /* Round corners for all cards */
}

.file-name {
  text-align: left;
  font-weight: bold;
  color: white;
  background: rgba(0, 0, 0, 0.8); /* Dark background behind file name */
  padding: 5px;
}

.rounded-corners {
  border-radius: 8px;
}

.download-btn {
  visibility: hidden;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.photo-card:hover .download-btn {
  visibility: visible;
}
</style>
